/* eslint-disable max-len */
import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const AttentionSignal = (props: Props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.16384 4.20627C8.4064 1.9979 11.5873 1.99793 12.8299 4.20627L17.5545 12.6067C18.7731 14.773 17.2079 17.4502 14.7224 17.4504H5.27127C2.78578 17.4502 1.22066 14.773 2.43923 12.6067L7.16384 4.20627ZM11.5222 4.94162C10.8531 3.75284 9.14057 3.75281 8.47146 4.94162L3.74588 13.342C3.08974 14.5085 3.93302 15.9502 5.27127 15.9504H14.7224C16.0607 15.9502 16.904 14.5085 16.2478 13.342L11.5222 4.94162ZM9.99978 12.9709C10.5521 12.9709 10.9998 13.4186 10.9998 13.9709C10.9998 14.5232 10.5521 14.9709 9.99978 14.9709C9.44762 14.9708 8.99978 14.5231 8.99978 13.9709C8.99979 13.4187 9.44763 12.9711 9.99978 12.9709ZM9.99978 6.22092C10.414 6.22092 10.7498 6.55671 10.7498 6.97092V10.9709C10.7498 11.3851 10.414 11.7209 9.99978 11.7209C9.58569 11.7208 9.24978 11.385 9.24978 10.9709V6.97092C9.24979 6.5568 9.5857 6.22107 9.99978 6.22092Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default AttentionSignal;
